import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function EmailRedirectHint({
	show = false,
	actualUserEmail = '',
	ariaLabel = 'test environment email recipient redirect hint',
	tooltipText = '',
	inline = false,
}) {
	const { t } = useTranslation('common');

	if (!show) {
		return null;
	}

	const defaultTooltipText = t('email_redirect_hint', {
		actualUserEmail,
	});

	if (inline) {
		return (
			<Box
				component="span"
				aria-label={ariaLabel}
				title={tooltipText || defaultTooltipText}
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					mx: 0.5,
					verticalAlign: 'middle',
					cursor: 'help',
				}}
			>
				<InfoOutlinedIcon fontSize="small" />
			</Box>
		);
	}

	return (
		<Tooltip title={tooltipText || defaultTooltipText} arrow>
			<IconButton size="small" aria-label={ariaLabel}>
				<InfoOutlinedIcon fontSize="small" />
			</IconButton>
		</Tooltip>
	);
}

EmailRedirectHint.propTypes = {
	show: PropTypes.bool,
	actualUserEmail: PropTypes.string,
	ariaLabel: PropTypes.string,
	tooltipText: PropTypes.string,
	inline: PropTypes.bool,
};

export default EmailRedirectHint;
